import { combineReducers } from "redux";
import transaction_history from "../features/serviceadmin/transaction_history/Slice";

const TransactionHistory = combineReducers({
  transaction_history: transaction_history,
});

export default TransactionHistory;
